import { h } from "preact";
import { observer } from "mobx-react";
import { t, translate } from "../../I18n";
import ButtonPrice from "../../components/ButtonPrice";
function CartFooter(props) {
    const { price, isContinueVisible, isSubmitDisabled, onContinue, onSubmit } = props;
    return (h("div", { class: "modal-footer modal-footer--sticky" },
        h("div", { class: "modal-footer__actions" },
            isContinueVisible && (h("button", { onClick: onContinue, class: "btn btn-default continue-shopping", type: "button", "data-ga-action": "Close cart (continue shopping clicks)", "data-testid": "cart/continueShopping", "data-field-id": "Cart.continueShopping" }, translate(t.restaurants.widgets.cart.hide))),
            " ",
            h("button", { onClick: onSubmit, class: `btn checkout btn-checkout ${isSubmitDisabled && "disabled"}`, type: "button", "data-testid": "Cart/submit", "data-field-id": "Cart.checkout" },
                translate(t.restaurants.widgets.cart.checkout),
                h(ButtonPrice, { dataFieldId: "Cart.price", price: price })))));
}
export default observer(CartFooter);
